import { Fetcher } from '@Types/fetcher'
import useBaseFetcher from '../base'

const appPurchaseOneTimeQuery = `
  query appPurchaseOneTime($chargeId: ID!) {
    node(id: $chargeId) {
      ... on AppPurchaseOneTime {
        createdAt
        id
        name
        status
        test
      }
    }
  }
`

function useCheckOneTimePurchase(): Fetcher {
  const [baseFetcher, meta] = useBaseFetcher()

  const checkOneTimePurchaseFetcher = async (chargeId: string) => {
    return await baseFetcher('shopify:admin/api/graphql.json', {
      method: 'POST',
      body: JSON.stringify({
        query: appPurchaseOneTimeQuery,
        variables: {
          chargeId: `gid://shopify/AppPurchaseOneTime/${chargeId}`,
        },
      }),
    })
  }

  return [checkOneTimePurchaseFetcher, meta]
}

export default useCheckOneTimePurchase
